<script setup lang="ts">
import { LayoutSelectorProps } from "@/cms/dialogs/LayoutSelector/LayoutSelector.types.ts";
import { computed } from "vue";
import LayoutSelectorItem from "@/cms/dialogs/LayoutSelector/LayoutSelectorItem.vue";
import Separator from "@/cms/components/ui/separator/Separator.vue";
import { LayoutOption } from "@/components/CMSComponents/layoutOptions.ts";

const props = withDefaults(defineProps<LayoutSelectorProps>(), {
  isSingleColumn: false,
  identifierProp: "name",
});

const selectedPropValue = defineModel<string>("selectedPropValue", {
  required: true,
});

const layoutSelectorItemContainerClasses = computed(() => ({
  "flex-shrink-0 gap-4 grid mb-8 md:grid-cols-2 lg:grid-cols-3 sm:grid-cols-1":
    !props.isSingleColumn,
  "flex-shrink-0 gap-2 flex flex-col": props.isSingleColumn,
}));

function itemClicked(layout: LayoutOption) {
  selectedPropValue.value = layout[
    props.identifierProp as keyof typeof layout
  ] as string;
}
</script>

<template>
  <div class="overflow-y-auto p-2" data-testid="layout-selector-items">
    <template
      v-for="(section, s) in Object.keys(layouts)"
      :key="`layout-section-${s}`"
    >
      <Separator :label="section" class="mb-8" />

      <div :class="layoutSelectorItemContainerClasses">
        <LayoutSelectorItem
          v-for="(layout, l) in layouts[section]"
          :key="`layout-${l}`"
          :layout
          :selected="selectedPropValue === layout[props.identifierProp as keyof typeof layout]"
          :data-layout-name="layout[props.identifierProp as keyof typeof layout]"
          @click="() => itemClicked(layout)"
        />
      </div>
    </template>
  </div>
</template>
